import { useEffect, useState } from "react";
import { toast } from "sonner";

import { subscribeNewsletter } from "@/services/newsletterService";
import { getErrorMessage } from "@/services/apiClient";
import { getPlatformStats } from "@/services/courseService";
import { useCountUp } from "@/my_components/Common/useCountUp";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    getPlatformStats()
      .then((res) => setStats(res.data))
      .catch(() => {});
  }, []);

  // Both counters below only render once `stats` is truthy, so `active` can just be `!!stats`.
  const studentsCount = useCountUp((stats?.total_students ?? 0) + 1000, Boolean(stats));
  const tracksCount = useCountUp((stats?.total_categories ?? 0) + 10, Boolean(stats));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const res = await subscribeNewsletter(email.trim());
      toast.success(res.message || "Subscribed!");
      setEmail("");
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container">
      <div className="row row--15 align-items-center">
        <div className="col-lg-12">

          <div className="inner text-center">
            <div className="section-title text-center">
              <span className="subtitle bg-white-opacity"> GET LATEST SMARTTECH ACADEMY UPDATE </span>
              <h2 className="title color-white"> Subscribe Our Newsletter </h2>
              <p className="description color-white mt--20">
                Be the first to get our latest articles, exclusive updates, and insider tips. Subscribe to our content and stay ahead with everything we share&mdash;directly to your inbox.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="newsletter-form-1 mt--40">
              <input
                type="email"
                placeholder="Enter your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="rbt-btn btn-md btn-gradient hover-icon-reverse" disabled={submitting}>
                <span className="icon-reverse-wrapper">
                  <span className="btn-text">{submitting ? "Subscribing…" : "Subscribe"}</span>
                  <span className="btn-icon">
                    <i className="feather-arrow-right"></i>
                  </span>
                  <span className="btn-icon">
                    <i className="feather-arrow-right"></i>
                  </span>
                </span>
              </button>
            </form>

            <span className="note-text color-white mt--20"> No ads, no trials, no commitments </span>

            {stats && (
              <div className="row row--15 mt--50">

                <div className={"col-lg-3 col-sm-6 col-md-6 single-counter offset-lg-3"} key="1">
                  <div className="rbt-counterup rbt-hover-03 style-2 text-color-white">
                    <div className="inner">
                      <div className="content">
                        <h3 className="counter color-white">
                          <span className="odometer">{studentsCount}</span>
                        </h3>
                        <h4 className="title color-white">Students Learning</h4>
                        <span className="subtitle color-white">
                          Across {stats.total_courses} free courses
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={"col-lg-3 col-sm-6 col-md-6 single-counter"} key="2">
                  <div className="rbt-counterup rbt-hover-03 style-2 text-color-white">
                    <div className="inner">
                      <div className="content">
                        <h3 className="counter color-white">
                          <span className="odometer">{tracksCount}</span>
                        </h3>
                        <h4 className="title color-white">Skill Tracks</h4>
                        <span className="subtitle color-white">
                          Taught by {stats.total_instructors} real instructors
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Newsletter;
